// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"dc3af41c","815":"dc3af41c"}[chunkId] + ".chunk.css";
};